module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "couponSelect",
    class: _vm.state ? 'couponSelectShow' : ''
  }, [_c('span', {
    staticClass: "couponSelectCont",
    on: {
      "click": function($event) {
        return _vm.stateFn(_vm.showState, 'show')
      }
    }
  }, [(_vm.counponDataFn.length > 0 && _vm.showStateType === '') ? _c('p', [_vm._v("选择优惠券")]) : (_vm.counponDataFn.length > 0 && _vm.showStateType === 'di') ? _c('p', [_vm._v("优惠券已抵扣"), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.showState))]), _vm._v("元")]) : (_vm.counponDataFn.length > 0 && _vm.showStateType === 'zhe') ? _c('p', [_vm._v("优惠券已折扣"), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.showState / 10))]), _vm._v("折")]) : _c('p', [_vm._v("暂无优惠券")])]), _vm._v(" "), _c('div', {
    staticClass: "couponSelectList"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "Content"
  }, [(_vm.counponDataFn.length <= 0) ? _c('div', [_c('p', [_vm._v("暂无优惠券")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/coupon/nused',
        query: {
          addState: true
        }
      }
    }
  }, [_vm._v("点击前往添加")])], 1) : (_vm.counponDataFn.length > 0) ? _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', [_c('span', {
    staticClass: "nonuseBut",
    on: {
      "click": function($event) {
        return _vm.stateFn('', 'nonuse')
      }
    }
  }, [_vm._v("不使用优惠券")])]), _vm._v(" "), _c('ul', _vm._l((_vm.counponDataFn), function(item, index) {
    return _c('li', {
      staticClass: "clear",
      class: _vm.acNum === index ? 'acLi' : '',
      on: {
        "click": function($event) {
          return _vm.stateFn(item, 'action', index)
        }
      }
    }, [(item.deductible) ? _c('div', {
      staticClass: "name"
    }, [_c('span', {
      staticClass: "badge deduction"
    }, [_vm._v("抵")]), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.title))])]) : _vm._e(), _vm._v(" "), (item.discount) ? _c('div', {
      staticClass: "name"
    }, [_c('span', {
      staticClass: "badge discount"
    }, [_vm._v("折")]), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.title))])]) : _vm._e(), _vm._v(" "), (item.end_time) ? _c('div', {
      staticClass: "time"
    }, [_vm._v("\n              " + _vm._s(item.end_time.split(' ')[0]) + "\n              "), _c('span', [_vm._v("到期")])]) : _c('div', {
      staticClass: "time"
    }, [_vm._v("\n              永久\n              "), _c('span', [_vm._v("使用")])]), _vm._v(" "), (item.deductible) ? _c('div', {
      staticClass: "val"
    }, [_c('span', {
      staticClass: "red"
    }, [_vm._v(_vm._s(item.deductible))]), _vm._v("元")]) : _vm._e(), _vm._v(" "), (item.discount) ? _c('div', {
      staticClass: "val"
    }, [_c('span', {
      staticClass: "red"
    }, [_vm._v(_vm._s(item.discount / 10))]), _vm._v("折\n            ")]) : _vm._e()])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "closeBut",
    on: {
      "click": _vm.stateFn
    }
  }, [_c('span', [_vm._v("X")])])]), _vm._v(" "), (_vm.state) ? _c('div', {
    staticClass: "module",
    on: {
      "click": _vm.stateFn
    }
  }) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Title"
  }, [_c('h2', [_vm._v("选择优惠券")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-195b72ff","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/couponSelect/src/couponSelect.vue
// module id = 509
// module chunks = 0